import Slider from "react-slick";
import React, { useEffect, useRef ,useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons";
import { isMap } from "lodash";

export function SavedCharts(props) {
const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const sliderRef = useRef(null);

  useEffect(() => {
    if (sliderRef.current) {console.log("in effect >> ");
      sliderRef.current.slickSetPosition(); // Force recalculation
    }
  }, []);

  return (
    <>
      {props.data && props.data.length > 0 && props.savedCharts.length > 0 ? (
        <div>
          <div className="md:mb-0 mb-16">
            <h1 className="text-2xl font-semibold leading-tight text-primaryColor mb-2 ml-4">
              Saved Charts
            </h1>
            <>
              <div className={`${props.mobileView ? "" : "ml-5 mr-2"}`}>
                {props.savedCharts && (props.savedCharts.length > 3 || isMobileView) ? (
                  <Slider
                   ref={sliderRef}
                    {...props.settings}
                    onTouchStart={props.onTouchStart}
                    onTouchEnd={props.onTouchEnd}
                    onMouseDown={props.onTouchStart}
                    onMouseUp={props.onTouchEnd}
                    className=""
                  >
                    {props.savedCharts && props.savedCharts.length > 0 ? (
                      props.savedCharts.map(props.callbackfn)
                    ) : (
                      <p>No charts available</p>
                    )}
                  </Slider>
                ) : (
                  <div className="grid md:grid-cols-4">
                    {props.savedCharts && props.savedCharts.length > 0 ? (
                      props.savedCharts.map(props.callbackfn1)
                    ) : (
                      <p>No charts available</p>
                    )}
                  </div>
                )}
              </div>
            </>
            {props.preview && (
              <>
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000, // Set a higher value to ensure it's above the sidebar
                  }}
                  onClick={props.onClick}
                >
                  <img
                    src={props.src}
                    alt="Preview"
                    style={{ maxWidth: "80%", maxHeight: "90%" }}
                  />
                  {/* <button
                    className="cursor-pointer text-white p-2 rounded-lg bg-primaryColor absolute md:top-4 top-[5rem] md:right-4 right-[2.4rem]"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      props.onClick();
                      props.onShareChartClick();
                    }}
                  >
                    Share <FontAwesomeIcon icon={faArrowUpFromBracket} />
                  </button> */}
                  <button
                    className="cursor-pointer text-white p-2 rounded-lg bg-primaryColor absolute md:top-16 top-[8rem] md:right-4 right-[2.4rem]"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      props.onClick();
                      props.shareChartAsPost();
                    }}
                  >
                    Share Chart As Post
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
